import type { GuideTourRuntimeState } from './types'

export const createInitialGuideTourState = (): GuideTourRuntimeState => ({
  status: 'idle',
  activeTourId: null,
  activeTour: null,
  currentStepIndex: 0,
  viewedStepCount: 0,
})
